import 'whatwg-fetch'
// import store from '../store'
import router from '../router'

/* eslint-disable */
function checkStatus(res) {
  if (res.status >= 200 && res.status < 300) {
    return res
  }
  const error = new Error(res.statusText)
  error.response = res
  return Promise.reject(error)
}

function parseJSON(res) {
  return res.json()
}

export default {
  get(baseurl, query = {}, headers = {}) {
    const keys = Object.keys(query).filter((v) => query[v] !== undefined)
    let url = keys.length === 0 ? baseurl : `${baseurl}?`
    keys.forEach((key) => {
      const val = encodeURIComponent(query[key])
      val && (url += `${key}=${val}&`)
    })
    url = url.replace(/&$/, '')
    const options = {
      method: 'GET',
      headers: new Headers(headers),
      mode: 'cors',
      credentials: 'include',
    }
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
  },
  post(baseurl, data, customOptions) {
    let formData = data
    if (!customOptions || customOptions.contentType !== 'application/json') {
      if (data instanceof FormData) {
        formData = data
      } else {
        formData = new FormData()
        for (const [key, value] of Object.entries(data)) {
          formData.append(key, value)
        }
      }
    }
    const url = baseurl
    const options = {
      method: 'POST',
      body: formData,
      mode: 'cors',
      credentials: 'include',
    }
    if (customOptions && customOptions.contentType === 'application/json') {
      options.headers = new Headers({
        'Content-Type': 'application/json',
      })
    }
    return fetch(url, Object.assign(options, customOptions))
      .then(checkStatus)
      .then(parseJSON)
  },
  put(baseurl, data) {
    let formData
    if (data instanceof FormData) {
      formData = data
    } else {
      formData = new FormData()
      for (const [key, value] of Object.entries(data)) {
        formData.append(key, value)
      }
    }
    const url = baseurl
    const options = {
      method: 'PUT',
      body: formData,
      mode: 'cors',
      credentials: 'include',
    }
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
  },
}
